// extracted by mini-css-extract-plugin
export default {"copy":"afa-z","sizingCopy":"bfa-z","predictedSize":"cfa-z","recommendedFitContainer":"dfa-z","recommendedFitIcon":"efa-z","recommendedFitText":"ffa-z"};